
export default {

  UPDATE_RESPONSE: 'UPDATE_RESPONSE',
  LOGOUT: 'LOGOUT',

  updateResponse(participant, stage, dataType, response) {
    return { type: this.UPDATE_RESPONSE, participant, stage, dataType, response };
  },

  logout() {
    return { type: this.LOGOUT };
  },
};
